import React from 'react';
import {
  Card, Typography, Divider, TagChip,
} from 'vindi-ds-components';

const ResumeProduct = ({
  status, invoice, id, plans,
}) => (
  <Card padding='xs'>
    <Typography variant='subtitle1'>Resumo</Typography>
    <Divider />
    <Typography variant='caption' component='h3'>Status do produto</Typography>
    <TagChip kind={status === 'active' ? 'success' : 'default'} label={status === 'active' ? 'Ativo' : 'Inativo'} /><br />
    <Typography variant='caption'>Tipo de produto</Typography>
    <Typography variant='body2'>{plans}</Typography>
    <Typography variant='caption'>Nota Fiscal</Typography>
    <Typography variant='body2'>{invoice === 'always' ? 'Emitir NF de produto' : 'Nunca'}</Typography>
    <Typography variant='caption'>ID de produto</Typography>
    <Typography>{id}</Typography>
  </Card>
);

export default ResumeProduct;
